// Observability for the courier ride flow: writes events to Conneo's shared
// timeline API (see ConneoFlowJS/js/timeline.js for the jQuery original this
// mirrors) so support can see what happened to a ride from the app's own
// perspective, without needing device access or Cloudflare log access.
//
// referenceId/traceId is namespaced APP_<rideId> - deliberately distinct from
// AND_Flow's own TRACE_RIDE_<rideId> entries (written server-side as a side
// effect of processRideAddressDelivery) - so the two don't collide or get
// double-prefixed, and so "what did the app do" can be told apart from "what
// did AND_Flow do" on the same ride.
//
// Best-effort only: a logging failure (network, CORS, ...) must never affect
// the courier flow, so this never throws and callers never await it.
const TIMELINE_URL = 'https://tools-v2.conneo.io/api/timeline';

const formatTimestamp = (ms) => {
  const d = new Date(ms);
  const pad = (n, len = 2) => String(n).padStart(len, '0');
  return `${pad(d.getFullYear(), 4)}${pad(d.getMonth() + 1)}${pad(d.getDate())}` +
    `:${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}${pad(d.getMilliseconds(), 3)}`;
};

export const logRideEvent = (conneoId, rideId, {
  eventName,
  eventType = 'Info',
  eventMessage,
  functionName = '',
  apiRequestContent,
  apiRequestResponseData,
  apiRequestUrl,
  extraData
}) => {
  // Debug routes (/DEBUG/rit/:jsonName) have no real rideId/conneoId - nothing
  // meaningful to trace, and nothing should be written to the shared timeline
  // for them.
  if (!rideId || !conneoId) return;
  try {
    const traceId = `APP_${rideId}`;
    const body = {
      customerId: conneoId,
      referenceId: traceId,
      traceId,
      applicationName: 'warehouse-picker',
      functionName,
      eventName,
      eventType,
      // The API rejects an empty eventMessage (400 "eventMessage is a required
      // field"); fall back to eventName so a call site that forgets one still
      // gets logged instead of silently dropped.
      eventMessage: eventMessage || eventName,
      apiRequestContent: apiRequestContent || {},
      apiRequestResponseData: apiRequestResponseData || {},
      apiRequestUrl: apiRequestUrl || '',
      extraData: extraData || '',
      timestamp: formatTimestamp(Date.now())
    };

    fetch(TIMELINE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    }).catch(() => {
      // best-effort only
    });
  } catch (err) {
    // never throw from logging
  }
};
